module.exports = __webpack_public_path__ + "img/02178349553182068d2074cd11e877100f87d4b1716fc61941c2e_0.90564299.webp";